// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"count_wrapper__FTNPJ","heading":"count_heading__IyU5P","count_wrapper":"count_count_wrapper__h4QuF","count_number":"count_count_number__5jU_0"};